export const tr = {
    'error-refresh': 'Hata oluştu. Lütfen, sayfayı yenilemeyi deneyin.',
    'no-rights': 'Önerileri görüntülemek için gerekli erişim izniniz yok'
};
